import classNames from "classnames";
import React from "react";
import styles from "./text.module.scss";

const Text = ({
  style,
  children,
  label,
  danger,
  strike,
  className,
  subtitle,
  align,
  strong,
  italic,
  underline,
  normal
}) => {
  const classes = classNames(styles.text, className, {
    [`${styles.label}`]: label,
    [`${styles.subtitle}`]: subtitle,
    [`${styles.strong}`]: strong,
    [`${styles.italic}`]: italic,
    [`${styles.danger}`]: danger,
    [`${styles.strike}`]: strike,
    [`${styles.underline}`]: underline,
    [`${styles.normal}`]: normal,
  });

  return (
    <div style={{ textAlign: align, ...style }} className={classes}>
      {children}
    </div>
  );
};

export default Text;
